import React, { useContext, useState } from "react";
import "./annexureCrudPopup.scss";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import AnnexureFormRender from "./AnnexureFormRender/AnnexureFormRender";
import { useImmer } from "use-immer";
import { dummyAnnexuresList1 } from "../DummyAnnexureConstants";
import { AnnexureContext } from "../annexureContext";
import { COLOR_PALLATE } from "../../../pcdoConstants";
// import { COLOR_PALLATE } from "../../../globalUtils/theme";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    backgroundColor: '#f4f4f4'
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function AnnexureCrudPopup({ annexureCrudPopupState, annexureData, onClose }) {
  const { handleSubmitData } = useContext(AnnexureContext)
  const { open, isEdit, initData, tableInstanceData } = annexureCrudPopupState;
  const { code, name, id, header } = annexureData
  const formJSON = header?.content ?? [];
  const [formData, setFormdata] = useImmer(initData);
  const handleFormDataChange = (fieldInfo, fieldVal) => {
    const { key, type } = fieldInfo;
    setFormdata((prev) => {
      prev[key] = fieldVal;
    });
  };
  const handleSubmit = (rawFormData) => {
    handleSubmitData(formJSON, rawFormData, annexureCrudPopupState)
    onClose()
  };

  return (
    <BootstrapDialog

      onClose={onClose}
      fullWidth={true}
      maxWidth={"lg"}
      open={open}
    >
      <DialogTitle sx={{ background: COLOR_PALLATE.mainColor, color: '#ffffff' }} id={code}>{code} - {name}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <AnnexureFormRender
          formData={formData}
          formJson={formJSON}
          handleFormDataChange={handleFormDataChange}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => handleSubmit(formData)}>
          Save changes
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default AnnexureCrudPopup;
